<footer class="p-2 fixed bottom-0 w-full bg-surface-opacity-5 z-1">
  <nav class="flex gap-3 justify-content-between">
    <a
      pButton
      class="no-underline text-color-secondary"
      severity="secondary"
      icon="fas fa-globe"
      size="small"
      label="Bertelsmann Stiftung"
      [text]="true"
      [rounded]="true"
      target="_blank"
      href="https://www.bertelsmann-stiftung.de/"></a>
    <a
      class="no-underline text-color-secondary"
      severity="secondary"
      pButton
      icon="fas fa-legal"
      size="small"
      label="Impressum"
      [text]="true"
      [rounded]="true"
      target="_blank"
      href="https://www.keck-atlas.de/system/impressum"></a>
    <a
      class="no-underline text-color-secondary"
      severity="secondary"
      pButton
      icon="fas fa-balance-scale"
      size="small"
      label="Datenschutz"
      [text]="true"
      [rounded]="true"
      target="_blank"
      href="https://www.keck-atlas.de/system/datenschutz"></a>
  </nav>
</footer>
